import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DropindataService {

  constructor() { }
     getData() {
        return [
          {
			 "Spessore_pannello": 6,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 7,
			  "art_comp": "XMS072470",
			  "tipoImpianto": "DI3NT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 6,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 14,
			  "art_comp": "XMS072471",
			  "tipoImpianto": "DI13NT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 6,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 17,
			  "art_comp": "XMS072472",
			  "tipoImpianto": "DI16NT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 6,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 22,
			  "art_comp": "XMS072479",
			  "tipoImpianto": "DI20NT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 6,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 28,
			  "art_comp": "XMS072480",
			  "tipoImpianto": "DI26NT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 6,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 6,
			  "art_comp": "XMS072470",
			  "tipoImpianto": "DI3NT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 6,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 9.4,
			  "art_comp": "XMS072471",
			  "tipoImpianto": "DI13NT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 6,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 13,
			  "art_comp": "XMS072472",
			  "tipoImpianto": "DI16NT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 6,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 17,
			  "art_comp": "XMS072479",
			  "tipoImpianto": "DI20NT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 6,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 22,
			  "art_comp": "XMS072480",
			  "tipoImpianto": "DI26NT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 7,
			  "art_comp": "XMS072473",
			  "tipoImpianto": "DI3NT S10",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 14,
			  "art_comp": "XMS072474",
			  "tipoImpianto": "DI13NT S10",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 17,
			  "art_comp": "XMS072475",
			  "tipoImpianto": "DI16NT S10",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 22,
			  "art_comp": "XMS072481",
			  "tipoImpianto": "DI20NT S10",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 28,
			  "art_comp": "XMS072482",
			  "tipoImpianto": "DI26NT S10",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 6,
			  "art_comp": "XMS072473",
			  "tipoImpianto": "DI3NT S10",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 9.4,
			  "art_comp": "XMS072474",
			  "tipoImpianto": "DI13NT S10",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 13,
			  "art_comp": "XMS072475",
			  "tipoImpianto": "DI16NT S10",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 17,
			  "art_comp": "XMS072481",
			  "tipoImpianto": "DI20NT S10",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-2/+8",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 22,
			  "art_comp": "XMS072482",
			  "tipoImpianto": "DI26NT S10",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-18/-20",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 7,
			  "art_comp": "XMS072476",
			  "tipoImpianto": "DI6LT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-18/-20",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 12,
			  "art_comp": "XMS072477",
			  "tipoImpianto": "DI13LT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-18/-20",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 19,
			  "art_comp": "XMS072478",
			  "tipoImpianto": "DI20LT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-18/-20",
			  "IdTemperaturaEsterna": 32,
			  "Volume": 26,
			  "art_comp": "XMS072483",
			  "tipoImpianto": "DI28LT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-18/-20",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 6,
			  "art_comp": "XMS072476",
			  "tipoImpianto": "DI6LT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-18/-20",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 10,
			  "art_comp": "XMS072477",
			  "tipoImpianto": "DI13LT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-18/-20",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 16,
			  "art_comp": "XMS072478",
			  "tipoImpianto": "DI20LT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			},
			{
			  "Spessore_pannello": 10,
			  "IdTemperaturaInterna": "-18/-20",
			  "IdTemperaturaEsterna": 43,
			  "Volume": 23,
			  "art_comp": "XMS072483",
			  "tipoImpianto": "DI28LT",
			  "stock": "NO",
			  "accessorio_bus_adapter": "MS017734",
			  "accessorio_bacinella_acqua": "MS093096"
			}


      ];
   }
}

